define("shared/components/shared/pre-boarding/survey/index", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "tracked-built-ins", "later/utils/string-formatters", "later/utils/time-format", "shared/utils/self-describes", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _service, _component2, _tracking, _emberConcurrency, _trackedBuiltIns, _stringFormatters, _timeFormat, _selfDescribes, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = _exports.HAS_SEEN_SELF_DESCRIBES = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _incrementSurveyIndex, _scrollToTop, _triggerSlideSegmentEvent;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"tracked-built-ins",0,"later/utils/string-formatters",0,"later/utils/time-format",0,"shared/utils/self-describes",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{#if this.shouldShowSelfDescribes}}
    <Shared::Wizard @closable={{false}} @focusTrap={{true}} as |wizard|>
      {{! QUESTIONS }}
      {{#each this.surveyQuestions as |questions index|}}
        <wizard.slide
          @id={{index}}
          @primaryClass="o--modalCard o--modalCard--narrow tUG--modalCard tUG--selfDescribe--modalCard"
          as |slide|
        >
          <slide.body>
            <div
              class="tUG--cardWrapper"
              data-test-survey="self-describes-body"
              id="self-describes-content"
              {{perfect-scroll suppressScrollX=true}}
            >
              {{! Question Card }}
              <div class="tUG--questionCard is--current">
                {{#each questions as |question|}}
                  {{#if (or (not question.shouldHideByDefault) this.shouldShowTextInput)}}
                    {{#if (not-eq question.identifier this.currentSlideTextInputIdentifier)}}
                      <header class="o--modalHeader u--p__b">
                        <small class="u--block u--m__b__xs u--text--xs u--text--light">
                          {{t
                            "onboarding.self_describes.counter"
                            numberOfSlides=this.surveyQuestions.length
                            questionIndex=(inc index)
                          }}
                        </small>
                        <h4 class="tUG--questionCard__question u--m__t__0 u--m__b__xs qa--self_desc_account_name">
                          {{question.text}}
                        </h4>
                        <p class="u--m__b__0">{{question.subText}}</p>
                      </header>
                    {{/if}}
                    <div class="o--modalBody">
                      <div class="tUG--questionCardWrapper">
                        {{#each question.options as |option|}}
                          {{component
                            question.surveyComponentName
                            hasInputError=this.hasInputError
                            index=index
                            inputTextFieldResponse=this.inputTextFieldResponse
                            numberOfColumns=question.numberOfColumns
                            onTouchEnd=this.onTouchEnd
                            onTouchMove=this.onTouchMove
                            onTouchStart=this.onTouchStart
                            option=option
                            otherInputLabel=question.text
                            question=question
                            selectRadioButtonResponse=this.selectRadioButtonResponse
                            surveyResponses=this.surveyResponses
                          }}
                        {{/each}}
                      </div>
                    </div>
                  {{/if}}
                {{/each}}
              </div>
            </div>
          </slide.body>
  
          <slide.footer>
            {{#if (is-last index this.surveyQuestions)}}
              <slide.finishButton
                @buttonClass="o--btn o--btn--primary"
                @isDisabled={{this.shouldDisableSubmitButton}}
                @promise={{this.submitSurvey}}
              >
                {{t "shared_words.done"}}
              </slide.finishButton>
            {{else}}
              <slide.nextButton
                @buttonClass="o--btn o--btn--primary u--flex u--flex__justify--center u--flex__alignItems--center tUG--questionCard__disabledBtn qa--self_desc_next_btn"
                @isDisabled={{this.hasUnansweredQuestion}}
                @onClick={{this.goToNextSurveySlide}}
                data-test-survey="next-button"
                {{on "click" this.clickNextWithUnansweredOther}}
              >
                {{t "shared_words.next"}}
                {{svg-jar "arrow-right" class="u--m__l__sm o--icon--sm o--icon--light u--text--white"}}
              </slide.nextButton>
            {{/if}}
          </slide.footer>
        </wizard.slide>
      {{/each}}
    </Shared::Wizard>
  {{/if}}
  */
  {
    "id": "iWN9+LPh",
    "block": "[[[41,[30,0,[\"shouldShowSelfDescribes\"]],[[[1,\"  \"],[8,[39,1],null,[[\"@closable\",\"@focusTrap\"],[false,true]],[[\"default\"],[[[[1,\"\\n\"],[42,[28,[37,3],[[28,[37,3],[[30,0,[\"surveyQuestions\"]]],null]],null],null,[[[1,\"      \"],[8,[30,1,[\"slide\"]],null,[[\"@id\",\"@primaryClass\"],[[30,3],\"o--modalCard o--modalCard--narrow tUG--modalCard tUG--selfDescribe--modalCard\"]],[[\"default\"],[[[[1,\"\\n        \"],[8,[30,4,[\"body\"]],null,null,[[\"default\"],[[[[1,\"\\n          \"],[11,0],[24,0,\"tUG--cardWrapper\"],[24,\"data-test-survey\",\"self-describes-body\"],[24,1,\"self-describes-content\"],[4,[38,4],null,[[\"suppressScrollX\"],[true]]],[12],[1,\"\\n\"],[1,\"            \"],[10,0],[14,0,\"tUG--questionCard is--current\"],[12],[1,\"\\n\"],[42,[28,[37,3],[[28,[37,3],[[30,2]],null]],null],null,[[[41,[28,[37,5],[[28,[37,6],[[30,5,[\"shouldHideByDefault\"]]],null],[30,0,[\"shouldShowTextInput\"]]],null],[[[41,[28,[37,7],[[30,5,[\"identifier\"]],[30,0,[\"currentSlideTextInputIdentifier\"]]],null],[[[1,\"                    \"],[10,\"header\"],[14,0,\"o--modalHeader u--p__b\"],[12],[1,\"\\n                      \"],[10,\"small\"],[14,0,\"u--block u--m__b__xs u--text--xs u--text--light\"],[12],[1,\"\\n                        \"],[1,[28,[35,8],[\"onboarding.self_describes.counter\"],[[\"numberOfSlides\",\"questionIndex\"],[[30,0,[\"surveyQuestions\",\"length\"]],[28,[37,9],[[30,3]],null]]]]],[1,\"\\n                      \"],[13],[1,\"\\n                      \"],[10,\"h4\"],[14,0,\"tUG--questionCard__question u--m__t__0 u--m__b__xs qa--self_desc_account_name\"],[12],[1,\"\\n                        \"],[1,[30,5,[\"text\"]]],[1,\"\\n                      \"],[13],[1,\"\\n                      \"],[10,2],[14,0,\"u--m__b__0\"],[12],[1,[30,5,[\"subText\"]]],[13],[1,\"\\n                    \"],[13],[1,\"\\n\"]],[]],null],[1,\"                  \"],[10,0],[14,0,\"o--modalBody\"],[12],[1,\"\\n                    \"],[10,0],[14,0,\"tUG--questionCardWrapper\"],[12],[1,\"\\n\"],[42,[28,[37,3],[[28,[37,3],[[30,5,[\"options\"]]],null]],null],null,[[[1,\"                        \"],[46,[30,5,[\"surveyComponentName\"]],null,[[\"hasInputError\",\"index\",\"inputTextFieldResponse\",\"numberOfColumns\",\"onTouchEnd\",\"onTouchMove\",\"onTouchStart\",\"option\",\"otherInputLabel\",\"question\",\"selectRadioButtonResponse\",\"surveyResponses\"],[[30,0,[\"hasInputError\"]],[30,3],[30,0,[\"inputTextFieldResponse\"]],[30,5,[\"numberOfColumns\"]],[30,0,[\"onTouchEnd\"]],[30,0,[\"onTouchMove\"]],[30,0,[\"onTouchStart\"]],[30,6],[30,5,[\"text\"]],[30,5],[30,0,[\"selectRadioButtonResponse\"]],[30,0,[\"surveyResponses\"]]]],null],[1,\"\\n\"]],[6]],null],[1,\"                    \"],[13],[1,\"\\n                  \"],[13],[1,\"\\n\"]],[]],null]],[5]],null],[1,\"            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"]],[]]]]],[1,\"\\n\\n        \"],[8,[30,4,[\"footer\"]],null,null,[[\"default\"],[[[[1,\"\\n\"],[41,[28,[37,11],[[30,3],[30,0,[\"surveyQuestions\"]]],null],[[[1,\"            \"],[8,[30,4,[\"finishButton\"]],null,[[\"@buttonClass\",\"@isDisabled\",\"@promise\"],[\"o--btn o--btn--primary\",[30,0,[\"shouldDisableSubmitButton\"]],[30,0,[\"submitSurvey\"]]]],[[\"default\"],[[[[1,\"\\n              \"],[1,[28,[35,8],[\"shared_words.done\"],null]],[1,\"\\n            \"]],[]]]]],[1,\"\\n\"]],[]],[[[1,\"            \"],[8,[30,4,[\"nextButton\"]],[[24,\"data-test-survey\",\"next-button\"],[4,[38,12],[\"click\",[30,0,[\"clickNextWithUnansweredOther\"]]],null]],[[\"@buttonClass\",\"@isDisabled\",\"@onClick\"],[\"o--btn o--btn--primary u--flex u--flex__justify--center u--flex__alignItems--center tUG--questionCard__disabledBtn qa--self_desc_next_btn\",[30,0,[\"hasUnansweredQuestion\"]],[30,0,[\"goToNextSurveySlide\"]]]],[[\"default\"],[[[[1,\"\\n              \"],[1,[28,[35,8],[\"shared_words.next\"],null]],[1,\"\\n              \"],[1,[28,[35,13],[\"arrow-right\"],[[\"class\"],[\"u--m__l__sm o--icon--sm o--icon--light u--text--white\"]]]],[1,\"\\n            \"]],[]]]]],[1,\"\\n\"]],[]]],[1,\"        \"]],[]]]]],[1,\"\\n      \"]],[4]]]]],[1,\"\\n\"]],[2,3]],null],[1,\"  \"]],[1]]]]],[1,\"\\n\"]],[]],null]],[\"wizard\",\"questions\",\"index\",\"slide\",\"question\",\"option\"],false,[\"if\",\"shared/wizard\",\"each\",\"-track-array\",\"perfect-scroll\",\"or\",\"not\",\"not-eq\",\"t\",\"inc\",\"component\",\"is-last\",\"on\",\"svg-jar\"]]",
    "moduleName": "shared/components/shared/pre-boarding/survey/index.hbs",
    "isStrictMode": false
  });
  const HAS_SEEN_SELF_DESCRIBES = _exports.HAS_SEEN_SELF_DESCRIBES = 'selfDescribes.completed';
  const COMPANY_SIZE_OVER_100_PEOPLE = ['101_999_people', 'over_1000_people'];
  let SelfDescribesComponent = _exports.default = (_class = (_incrementSurveyIndex = /*#__PURE__*/new WeakSet(), _scrollToTop = /*#__PURE__*/new WeakSet(), _triggerSlideSegmentEvent = /*#__PURE__*/new WeakSet(), class SelfDescribesComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _classPrivateMethodInitSpec(this, _triggerSlideSegmentEvent);
      _classPrivateMethodInitSpec(this, _scrollToTop);
      _classPrivateMethodInitSpec(this, _incrementSurveyIndex);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "errors", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _initializerDefineProperty(this, "onboarding", _descriptor4, this);
      _initializerDefineProperty(this, "segment", _descriptor5, this);
      _initializerDefineProperty(this, "store", _descriptor6, this);
      _initializerDefineProperty(this, "userAgent", _descriptor7, this);
      _initializerDefineProperty(this, "surveyIndex", _descriptor8, this);
      _initializerDefineProperty(this, "shouldShowModal", _descriptor9, this);
      _initializerDefineProperty(this, "_hasInputError", _descriptor10, this);
      _initializerDefineProperty(this, "surveyResponses", _descriptor11, this);
      _defineProperty(this, "didUserTap", false);
      _defineProperty(this, "segmentEventNames", ['added-best-describes', 'added-company-size', 'added-team-size', 'added-main-reason-using-later']);
      _defineProperty(this, "createSelfDescribesCompletedField", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          const selfDescribesCompletedDiscoveryListField = this.store.createRecord('discovery-list-task', {
            identifier: HAS_SEEN_SELF_DESCRIBES,
            completedTime: (0, _timeFormat.timestamp)(),
            user: this.auth.currentUserModel
          });
          try {
            yield selfDescribesCompletedDiscoveryListField.save();
          } catch (error) {
            this.errors.log(error);
          }
        }
      }), null, "createSelfDescribesCompletedField", null));
      _defineProperty(this, "submitSurvey", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          _classPrivateMethodGet(this, _triggerSlideSegmentEvent, _triggerSlideSegmentEvent2).call(this);
          yield this.saveAnswers.perform();
          yield this.createSelfDescribesCompletedField.perform();
          yield this.segment.identify.perform(this.currentUserModel.id, this.currentAccount.id);
          this.shouldShowModal = false;
          this.args.onCloseSelfDescribes();
        }
      }), null, "submitSurvey", null));
      _defineProperty(this, "saveAnswers", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          this.auth.currentAccount.setProperties({
            bestDescribes: this.surveyResponses.bestDescribes,
            bestDescribesOther: this.surveyResponses.bestDescribesOther,
            companySize: this.surveyResponses.companySize,
            teamSize: this.surveyResponses.teamSize,
            reasonForUsingLater: this.surveyResponses.reasonForUsingLater,
            selfDescribesCompanyName: this.surveyResponses.companyName
          });
          yield this.auth.currentAccount.save().catch(error => this.errors.handleAdapter(error));
        }
      }), null, "saveAnswers", null));
    }
    get surveyQuestions() {
      return (0, _selfDescribes.surveyQuestions)(this.intl, this.currentUserModel);
    }
    get surveyMap() {
      return this.surveyQuestions.map(surveySlideQuestions => surveySlideQuestions.map(question => question.identifier));
    }
    get shouldShowTextInput() {
      if (this.surveyIndex === 0) {
        return this.surveyResponses.bestDescribes === 'other';
      }
      if (this.surveyIndex === 1) {
        return COMPANY_SIZE_OVER_100_PEOPLE.includes(this.surveyResponses.companySize ?? '');
      }
      return false;
    }
    get currentUserModel() {
      return this.auth.currentUserModel;
    }
    get currentSlideTextInputIdentifier() {
      return this.surveyMap[this.surveyIndex].find(identifier => identifier === 'bestDescribesOther' || identifier === 'companyName');
    }
    get currentAccount() {
      return this.auth.currentAccount;
    }
    get hasInputError() {
      return this._hasInputError;
    }
    get hasUnansweredQuestion() {
      return this.surveyMap[this.surveyIndex].some(identifier => {
        const isBestDescribeQuestion = identifier === 'bestDescribes' || identifier === 'bestDescribesOther';
        const isAnswerOther = this.surveyResponses.bestDescribes === 'other' || this.surveyResponses.bestDescribes === undefined;
        const isCompanyNameQuestion = identifier === 'companyName';
        if (isBestDescribeQuestion && !isAnswerOther) {
          return false;
        }
        if (isCompanyNameQuestion) {
          return false;
        }
        return this.surveyResponses[identifier] === undefined || this.surveyResponses[identifier]?.trim() === '';
      });
    }
    get shouldDisableSubmitButton() {
      return this.hasUnansweredQuestion || this.saveAnswers.isRunning || this.segment.identify.isRunning;
    }
    get shouldShowSelfDescribes() {
      const hasSelfDescribed = this.currentAccount.bestDescribes && !this.saveAnswers.last;
      const isSelfDescribingNow = Boolean(this.saveAnswers.last?.isSuccessful);
      return this.shouldShowModal && !this.onboarding.shouldSkipSelfDescribes && (!hasSelfDescribed || isSelfDescribingNow) && !this.auth.currentGroup?.contributor && this.onboarding.onFirstOnboardingStep && !this.hasSeenSelfDescribes;
    }
    get hasSeenSelfDescribes() {
      return Boolean(this.auth.discoveryListTasks?.find(_ref => {
        let {
          identifier
        } = _ref;
        return identifier === HAS_SEEN_SELF_DESCRIBES;
      }));
    }
    clickNextWithUnansweredOther() {
      if (this.surveyResponses.bestDescribes === 'other' && this.surveyMap[this.surveyIndex][0] === 'bestDescribes' && this.hasUnansweredQuestion) {
        this._hasInputError = true;
      }
    }
    inputTextFieldResponse(_ref2) {
      let {
        target
      } = _ref2;
      if (target.value.trim() !== '') {
        this._hasInputError = false;
      }
      if (this.surveyIndex === 0) {
        this.surveyResponses.bestDescribesOther = target.value;
      } else if (this.surveyIndex === 1) {
        this.surveyResponses.companyName = target.value;
      }
    }
    selectRadioButtonResponse(identifier, response) {
      const isBestDescribeQuestion = identifier === 'bestDescribes' && response !== 'other';
      const isCompanySizeQuestion = identifier === 'companySize' && !COMPANY_SIZE_OVER_100_PEOPLE.includes(response);
      if (isBestDescribeQuestion) {
        this._hasInputError = false;
        this.surveyResponses.bestDescribesOther = undefined;
        _classPrivateMethodGet(this, _scrollToTop, _scrollToTop2).call(this);
      }
      if (isCompanySizeQuestion) {
        this.surveyResponses.companyName = undefined;
        _classPrivateMethodGet(this, _scrollToTop, _scrollToTop2).call(this);
      }
      this.surveyResponses[identifier] = response;
    }
    goToNextSurveySlide() {
      _classPrivateMethodGet(this, _triggerSlideSegmentEvent, _triggerSlideSegmentEvent2).call(this);
      _classPrivateMethodGet(this, _incrementSurveyIndex, _incrementSurveyIndex2).call(this);
    }

    /**
     * The following touch event handlers are implemented to mitigate a bug with touch devices.
     * The issue is that the first touch event is not registered as a click event and thus
     * if the user selects an option with the first touch, the option is not selected.
     */
    onTouchStart(event) {
      event.preventDefault();
      this.didUserTap = true;
    }
    onTouchMove(event) {
      event.preventDefault();
      this.didUserTap = false;
    }
    onTouchEnd(identifier, response, event) {
      event.preventDefault();
      if (this.didUserTap) {
        this.selectRadioButtonResponse(identifier, response);
      }
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "onboarding", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "userAgent", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "surveyIndex", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return 0;
    }
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "shouldShowModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return true;
    }
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "_hasInputError", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "surveyResponses", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return new _trackedBuiltIns.TrackedObject({
        bestDescribes: undefined,
        bestDescribesOther: undefined,
        companySize: undefined,
        teamSize: undefined,
        reasonForUsingLater: undefined,
        companyName: undefined
      });
    }
  }), _applyDecoratedDescriptor(_class.prototype, "clickNextWithUnansweredOther", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "clickNextWithUnansweredOther"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "inputTextFieldResponse", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "inputTextFieldResponse"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectRadioButtonResponse", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "selectRadioButtonResponse"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goToNextSurveySlide", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "goToNextSurveySlide"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onTouchStart", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onTouchStart"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onTouchMove", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onTouchMove"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onTouchEnd", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onTouchEnd"), _class.prototype)), _class);
  function _incrementSurveyIndex2() {
    this.surveyIndex += 1;
  }
  function _scrollToTop2() {
    if (this.userAgent.device.isMobile) {
      return;
    }
    const slideWithOtherInput = document.getElementById('self-describes-content');
    slideWithOtherInput.scrollTop = 0;
  }
  function _triggerSlideSegmentEvent2() {
    const segmentEventData = this.surveyMap[this.surveyIndex].reduce((populatedSegmentEvents, key) => ({
      ...populatedSegmentEvents,
      [(0, _stringFormatters.camelToSnake)(key)]: this.surveyResponses[key]
    }), {});
    this.segment.track(this.segmentEventNames[this.surveyIndex], segmentEventData);
  }
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SelfDescribesComponent);
});